import { Injectable } from '@angular/core';
import { NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { CustomDialogComponent } from './custom-dialog.component';

@Injectable({ providedIn: 'root' })
export class CvCustomDialogService {

    constructor(
        private modalService: NgbModal
    ) { }

    /**
     * 
     * @param title Modal title
     * @param body Modal description
     * @param dialogType According to the dialogType, the modal will display a different icon and buttom style.
     * @param cancelButtonText The text of the cancel buttom
     * @param confirmButtonText The text of the confirm buttom
     * @param isCXOne Load cxone styles if isCxone = true
     * @param okCallback Action triggered when the user clicks on the confirm buttom
     * @param cancelCallback Action triggered when the user clicks on the cancel buttom
     * @param customModalClass Modal class
     * @param isInnerHtml To display a custom html
     * @returns NgbModalRef object
     */
    showDialog(title: string, body: string | string[], dialogType: number, cancelButtonText: string, confirmButtonText: string, isCXOne: boolean, okCallback = this.emptyCallBack, cancelCallback = this.emptyCallBack, customModalClass = '', isInnerHtml = false, customModalConfig:NgbModalOptions = this.modalConfig()) {
        const modalRef = this.modalService.open(CustomDialogComponent, customModalConfig);
        const instance: CustomDialogComponent = modalRef.componentInstance;
        instance.customModalClass = customModalClass;
        instance.title = title;
        instance.body = body;
        instance.dialogType = dialogType;
        instance.cancelButtonText = cancelButtonText;
        instance.confirmButtonText = confirmButtonText;
        instance.isCXone = isCXOne;
        instance.isInnerHtml = isInnerHtml;
        modalRef.result.then(okCallback, cancelCallback);
        return modalRef;
    }

    modalConfig(): NgbModalOptions {
        const modalOptions: NgbModalOptions = {
            centered: true,
        };
        return modalOptions;
    }
    private emptyCallBack = () => { };

}